"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WrappedPropertyBase_1 = require("./WrappedPropertyBase");
var WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
var functions_1 = require("./functions");
var fixDateFormat_1 = require("../JSchema/fixDateFormat");
var getRuleMessage_1 = require("../JSchema/getRuleMessage");
/**
 * obiekt reprezentujący pole tkestowe
 *
 * @export
 * @class WrappedPropertyString
 * @extends {WrappedPropertyBase<IInternal>}
 * @implements {IWrappedProperty}
 */
var WrappedPropertyString = /** @class */ (function (_super) {
    __extends(WrappedPropertyString, _super);
    function WrappedPropertyString(dest, parent, propName, schema, options) {
        var _this = _super.call(this, dest, parent, propName, schema, options) || this;
        functions_1.wrapSchemaProps(_this.$schema, _this._internal, 'number', [
            'maxLength',
            'minLength',
            'minimum',
            'maximum',
            'exclusiveMaximum',
            'exclusiveMinimum'
        ]);
        if (_this.$schema.warnings) {
            functions_1.wrapWarningProps(_this.$schema, _this._internal, 'number', [
                'maxLength',
                'minLength',
                'minimum',
                'maximum',
                'exclusiveMaximum',
                'exclusiveMinimum'
            ]);
        }
        functions_1.initVue(_this, _this._internal);
        return _this;
        // console.log('string created', propName, this._internal.vmUserData);
    }
    /**
     * sprawdza pole pod kątem błedów
     *
     * @param {*} [value] wartość
     * @param {boolean} [skipDirty] czy ma nie zaznaczać pola jako dirty
     * @returns {(string | null)} wynik
     * @memberof WrappedPropertyNumber
     */
    WrappedPropertyString.prototype.$validate = function (value, skipDirty) {
        if (this.$disabled) {
            return null;
        }
        if (value === undefined) {
            value = this.$model;
        }
        if (!skipDirty) {
            this.$dirty = true;
        }
        var req = this.$schema.fieldRequired;
        // console.log('propName.get()', req, svalue);
        if (value === '' || value === null) {
            if (this.$schema.fieldRequired) {
                // console.timeEnd('(string)$validate');
                var message = getRuleMessage_1.getRuleMessage(this._internal, 'required', value, this.$schema);
                this.$validateResult = {
                    validation: 'required',
                    message: message,
                    expected: true
                };
                return message;
            }
            if (this.$schema.enum && this.$schema.enum.indexOf(value) === -1) {
                // return getRuleMessage(this._internal, 'enum', value, this.$schema);
                var message = getRuleMessage_1.getRuleMessage(this._internal, 'enum', value, this.$schema);
                this.$validateResult = {
                    validation: 'enum',
                    message: message,
                    expected: this.$schema.enum
                };
                return message;
            }
            return null;
        }
        // console.timeEnd('(string)$validate');
        return _super.prototype.$validate.call(this, value);
    };
    /**
     * sprawdza pole pod kątem ostrzeżeń
     *
     * @param {*} [value] wartośc pola
     * @param {string[]} [checkResult]
     * @returns {string[]} lista ostrzeżeń lub pusta tablica
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyString.prototype.$check = function (value, checkResult) {
        if (this.$disabled) {
            return [];
        }
        if (this._internal.schema.warnings) {
            if (value === undefined) {
                value = this.$model;
            }
            this.$dirty = true;
            checkResult = checkResult || [];
            var req = this.$schema.warnings.fieldRequired;
            // console.log('propName.get()', req, svalue);
            if (value === '' || value === null) {
                if (req) {
                    // console.timeEnd('(string)$validate');
                    checkResult.push(getRuleMessage_1.getRuleMessage(this._internal, 'required', value, this.$schema));
                }
                if (this.$schema.warnings.enum && this.$schema.warnings.enum.indexOf(value) === -1) {
                    checkResult.push(getRuleMessage_1.getRuleMessage(this._internal, 'enum', value, this.$schema));
                }
                if (value === null)
                    return checkResult;
            }
            // console.timeEnd('(string)$validate');
            return _super.prototype.$check.call(this, value, checkResult);
        }
        return [];
    };
    /**
     * naprawia format daty we wszytkich elementach tablicy
     *
     * @returns {number}
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyString.prototype.$fixDateFormat = function () {
        switch (this._internal.schema.format) {
            case 'date':
                // this._internal.parent, this.$key, value
                return fixDateFormat_1.fixDateField(this._internal.parent, this.$key, this._options.Vue) ? 1 : 0;
            case 'date-time':
                return fixDateFormat_1.fixDateTimeField(this._internal.parent, this.$key, this._options.Vue) ? 1 : 0;
        }
        return 0;
    };
    /**
     * pobranie wartości z modelu
     *
     * @protected
     * @returns {*}
     * @memberof WrappedPropertyNumber
     */
    WrappedPropertyString.prototype.getValue = function () {
        var svalue = this.$model;
        if (svalue !== null) {
            switch (this.$schema.format) {
                case 'date':
                    if (svalue && svalue.length >= 10) {
                        var nsvalue = svalue.substr(8, 2) + "." + svalue.substr(5, 2) + "." + svalue.substr(0, 4);
                        svalue = nsvalue;
                    }
                    break;
                case 'date-time':
                    if (svalue && svalue.length >= 10) {
                        var nsvalue = svalue.substr(8, 2) + "." + svalue.substr(5, 2) + "." + svalue.substr(0, 4);
                        if (svalue.length === 19) {
                            var ntvalue = svalue.substr(11, 8);
                            // if (ntvalue !== '00:00:00') {
                            nsvalue += ' ' + ntvalue;
                            // }
                        }
                        // console.log('get date-time', svalue, nsvalue, ntvalue);
                        svalue = nsvalue;
                    }
                    break;
            }
        }
        return svalue || '';
    };
    /**
     * ustawienie wartości na modelu
     *
     * @protected
     * @param {*} newValue
     * @returns
     * @memberof WrappedPropertyNumber
     */
    WrappedPropertyString.prototype.setValue = function (newValue) {
        if (this.$disabled) {
            return;
        }
        // check save type
        if (newValue !== null) {
            if (this.$schema.format) {
                switch (this.$schema.format) {
                    case 'date':
                        if (newValue && newValue.length >= 10) {
                            newValue = newValue.substr(6, 4) + "-" + newValue.substr(3, 2) + "-" + newValue.substr(0, 2);
                        }
                        break;
                    case 'date-time':
                        if (newValue && newValue.length >= 10) {
                            if (newValue.length === 19) {
                                newValue = newValue.substr(6, 4) + "-" + newValue.substr(3, 2) + "-" + newValue.substr(0, 2) + " " + newValue.substr(11);
                            }
                            else {
                                newValue = newValue.substr(6, 4) + "-" + newValue.substr(3, 2) + "-" + newValue.substr(0, 2) + " 00:00:00";
                            }
                        }
                        break;
                }
            }
        }
        this.$model = newValue;
        if (!this.$dirty && this._options.dirtyOnInput) {
            this.$dirty = true;
        }
    };
    return WrappedPropertyString;
}(WrappedPropertyBase_1.default));
exports.default = WrappedPropertyString;
WrappedPropertyCtor_1.default.string = WrappedPropertyString;
//# sourceMappingURL=WrappedPropertyString.js.map